import axios from "axios";
export default async function sendDrivingCommand(cartNumber,relevantUrl, p_command) {
    //p_command : 'stop' || 'drive  
    const command = p_command.toLowerCase() ==='pause' ?"PAUSE":'DRIVE';
    if(command){
        try {
            const data = {
                cart_number: cartNumber,
                drivingCommand: command
            }
            console.log(relevantUrl +`/admin/drivingCommandFromSiteManager`);
            const response = await axios.post(relevantUrl +`/admin/drivingCommandFromSiteManager`, data);
        
            if(response.status === 200){
                return 'ok';
            }else{
                console.log("ERROR setDrivingCommand");
                return 'error';
            }
        } catch (error) {
            console.log("ERROR setDrivingCommand" ,error);
            return 'error';
        }
    }
}